export default __webpack_public_path__ + "static/media/eth-icon.2f5a8b96.svg";